import React, {useEffect, useState} from "react";
import UserService from "../../../services/UserService";
import {buildCSSFormGroupInput} from "../../../utils/BubblyUIUtils";
import {connect} from "react-redux";
import {withToastManager} from "react-toast-notifications";
import LoadingIndicator from "../../meta/LoadingIndicator";

function PersonalInformationSection(props) {
    const [userName, setUserName] = useState("");
    const [userCompanyName, setUserCompanyName] = useState("");
    const [isSaveButtonDisplayed, setIsSaveButtonDisplayed] = useState(false);

    useEffect(() => {
        setIsSaveButtonDisplayed(false);
        UserService.getPersonalInformation(props.userId, (success) => {
            const personalInformation = success.data;
            setUserName(personalInformation.user_surname);
            setUserCompanyName(personalInformation.user_company_name);
            setIsSaveButtonDisplayed(true);
        },(error) =>{
            setIsSaveButtonDisplayed(false);
        });
    }, []);

    function onUserNameChange(e) {
        const newUserName = e.target.value;
        setUserName(newUserName);
        ! isSaveButtonDisplayed && setIsSaveButtonDisplayed(true);
        buildCSSFormGroupInput(e, "userNameFormGroup", "userNameFormGroupError", !!newUserName);
    }

    function onCompanyNameChange(e) {
        setUserCompanyName(e.target.value);
        ! isSaveButtonDisplayed && setIsSaveButtonDisplayed(true);
    }

    function onSaveButtonClick(e) {
        e.preventDefault();
        setIsSaveButtonDisplayed(false);
        if(!userName){
            props.toastManager.add("Your user name cannot be empty.", {
                appearance: 'error'
            });
        }
        else {
            const userAndCompanyNamePayload = {
                user_surname: userName,
                user_company_name: userCompanyName
            };
            setIsSaveButtonDisplayed(false);
            UserService.savePersonalInformation(props.userId, userAndCompanyNamePayload, () => {
                props.toastManager.add('Your personal information was updated', {
                    appearance: 'success'
                });
                setIsSaveButtonDisplayed(true);
            }, (error) => {
                setIsSaveButtonDisplayed(false);
            });
        }
    }

    return (
        <div className="account__section">
            <div className="account__section__colLeft">
                <div className="account__section__colLeft_title">Personal information</div>
                <div className="account__section__colLeft_description"></div>
            </div>
            <div className="account__section__colRight">
                <form action="" className="form">
                    <div className="form__group" id="userNameFormGroup">
                        <div className="form__group__input">
                            <input
                                className="form__group__input__text"
                                name="user_surname"
                                type="text"
                                placeholder="Full Name"
                                value={userName}
                                disabled = {!isSaveButtonDisplayed}
                                onChange={onUserNameChange} />
                            <span className="form__group__input__icon"><img src="./assets/img/login_page/user.png" alt="" /></span>
                        </div>
                        <span className="form__group__error" id="userNameFormGroupError">Please specifiy a name</span>
                    </div>
                    <div className="form__group">
                        <div className="form__group__input">
                            <input
                                className="form__group__input__text"
                                name="user_company_name" type="text"
                                placeholder="Company Name"
                                value={userCompanyName}
                                disabled = {!isSaveButtonDisplayed}
                                onChange={onCompanyNameChange} />
                            <span className="form__group__input__icon"><img src="./assets/img/user_account/briefcase.png" alt="" /></span>
                        </div>
                    </div>
                    {isSaveButtonDisplayed ?
                        <>
                            <br/>
                            <a href="#" onClick={onSaveButtonClick} className="cta--normal questionaire__builder__question__action__save">SAVE</a>
                        </> :   <LoadingIndicator/>
                    }
                </form>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        userId: state.user.user.userId
    };
};

export default connect(mapStateToProps)(withToastManager(PersonalInformationSection));